import React, { useCallback, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import "../../css/others/Table.css";
import Pagination from "../../Reusablecomponents/Pagination";
import { apiCall } from "../../main/ApiCall";
import { GlobalChecklistDetail } from "../../interFaces/interfaces";
const GlobalTemplatesDetails: React.FC = () => {
  const { localTemplateId } = useParams<{ localTemplateId: string }>();
  const location = useLocation();
  const { isIntegratedChecklist, controls = [] } = (location.state || { isIntegratedChecklist: false, controls: [] }) as { isIntegratedChecklist: boolean; controls: string[] };
  const [details, setDetails] = useState<GlobalChecklistDetail[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const fetchChecklistDetails = useCallback(async () => {
    if (!localTemplateId) return;
    setLoading(true);
    try {
      const response = await apiCall("get", `/api/local-templates/base-templates/${localTemplateId}/questions`, null, { page: currentPage - 1, size: itemsPerPage });
      setDetails(response.content || []);
      setTotalPages(response.totalPages || 0);
      setTotalElements(response.totalElements || 0);
    } catch (error) {
      console.error("Error fetching checklist details:", error);
    }
  }, [localTemplateId, currentPage, itemsPerPage]);
  useEffect(() => {
    fetchChecklistDetails();
  }, [fetchChecklistDetails]);
  const controlKeyMap: Record<string, keyof GlobalChecklistDetail> = { "PIMS": "pims", "ISMS": "isms", "BCMS": "bcms", "CMMI": "cmmi", "SOC1": "soc1", "SOC2": "soc2", "QMS": "qms", "AIMS": "aims", "ERM": "erm", "ITSM": "itsm", "ERS": "ers", "OHS": "ohs" };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Global Base Template Details</h2>
      </div>
      <div className="table-container">
        <div className="table">
          <table className="main-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th className="header-width">Question</th>
                <th className="header-width">Expected Artifact</th>
                {!isIntegratedChecklist && <th className="header-width">Control/Practice Area</th>}
                {isIntegratedChecklist && controls.map((ctrl) => <th key={ctrl} className="header-width">{ctrl}</th>)}
              </tr>
            </thead>
            <tbody>
              {details.length > 0 ? (
                details.map((item, index) => (
                  <tr key={item.questionId}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.questionText || "Empty"}</td>
                    <td>{item.expectedArtifact || "Empty"}</td>
                    {!isIntegratedChecklist && (
                      <td>{item.practiceArea || "Empty"}</td>
                    )}
                    {isIntegratedChecklist &&
                      controls.map((ctrl) => {
                        const key = controlKeyMap[ctrl];
                        const value = key ? item[key] : null;
                        return <td key={ctrl}>{value || "Empty"}</td>;
                      })}
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no-data" colSpan={isIntegratedChecklist ? 3 + controls.length : 4}> No questions available for this checklist</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
    </div>
  );
};
export default GlobalTemplatesDetails;